
export const categories = [
  {
    id: '1',
    page: 'products',
    name: 'Deportivos',
    image: 'deportivos'
  },
  {
    id: '2',
    page: 'products',
    name: 'Electrónicos',
    image: 'electronicos'
  },
  {
    id: '3',
    page: 'products',
    name: 'Hogar',
    image: 'hogar'
  },
  {
    id: '4',
    page: 'products',
    name: 'Jardinería',
    image: 'jardineria'
  },
  {
    id: '5',
    page: 'products',
    name: 'Prendas de vestir',
    image: 'prendaVestir'
  },
  {
    id: '6',
    page: 'products',
    name: 'Otros',
    image: 'otros'
  },
  {
    id: '7',
    page: 'services',
    name: 'Autónomo',
    image: 'autonomo'
  },
  {
    id: '8',
    page: 'services',
    name: 'Costura',
    image: 'costura'
  },
  {
    id: '9',
    page: 'services',
    name: 'Guarañar',
    image: 'guarañar'
  },
  {
    id: '10',
    page: 'services',
    name: 'Limpieza',
    image: 'limpieza'
  },
  {
    id: '11',
    page: 'services',
    name: 'Pintar',
    image: 'pintar'
  },
  {
    id: '12',
    page: 'services',
    name: 'Manicura',
    image: 'manicura'
  }
]